import { GamesCard } from '../Shares/GamesCard';
import { games } from '../Shares/games';
export const Services: React.FC = () => {
  const tops = games.find(item => item.id === 'tops');
  const primes = games.find(item => item.id === 'primes');
  const slots = games.find(item => item.id === 'slots');
  const lives = games.find(item => item.id === 'lives');
  return <>
      <GamesCard id={tops?.id || ''} title={tops?.title} items={tops?.items || []} />
      <GamesCard id={primes?.id || ''} title={primes?.title} items={primes?.items || []} />
      <GamesCard id={slots?.id || ''} title={slots?.title} items={slots?.items || []} />
      <GamesCard id={lives?.id || ''} title={lives?.title} items={lives?.items || []} />
    </>;
};